import React from 'react'
import { Message } from 'mage-i18n'
import { SpacerVertical, TitleSecondary } from '@klarna/bubble-ui'
import SupportButton from '../SupportPage/SupportButton'

export default function SearchSupportButton () {
  return (
    <>
      <TitleSecondary>
        <Message path='help-tool.search.results.contact' fallback="Can't find the help you need?" />
      </TitleSecondary>
      <SpacerVertical small />
      <SupportButton analyticsCategory='uhqm/support-button/search' />
      <SpacerVertical medium />
    </>
  )
}
